import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getLogicalTreeData(params) {
    return axios.post(`${baseUrl}/common/tree/get-logical-tree.do`, params);
  },
  getPhysicalTreeData(params) {
    return axios.post(`${baseUrl}/common/tree/get-physical-tree.do`, params);
  },
  /**
   * 관리 대상의 논리 그룹 트리에서의 treeKey를 반환한다.
   * @author Ju
   * @param  {Number} objId treeKey를 구할 관리 대상의 objId
   * @return {String}       관리대상의 논리 그룹 트리의 treeKey
   */
  getTreeKey(objId, managegroupIds, treeType) {
    return axios.post(`${baseUrl}/common/tree/get-tree-key.do`, { objId, managegroupIds, treeType: `${treeType}_` });
  },
  /**
   * 벤더별 관리 대상 개수를 조회한다.
   * @author Ju
   * @param  {String} managetypeId [description]
   */
  getObjCountByCompany(managetypeId) {
    return axios.get(`${baseUrl}/common/tree/get-obj-count-by-company.do`, {
      params: {
        managetypeId,
      },
    });
  },
  /**
   * 장비구분별 관리 대상 개수를 조회한다.
   * @param  {String} managetypeId [description]
   */
  getObjCountByType(managetypeId) {
    return axios.get(`${baseUrl}/common/tree/get-obj-count-by-type.do`, {
      params: {
        managetypeId,
      },
    });
  },
  /**
   * 하이퍼바이저 타입별 관리 대상 개수를 조회한다.
   * @param  {String} managetypeId 관리 구분 아이디
   */
  getObjCountByHypervisorType(managetypeId) {
    return axios.get(`${baseUrl}/common/tree/get-obj-count-by-hypervisor-type.do`, {
      params: {
        managetypeId,
      },
    });
  },
  /**
   * 논리 / 물리 그룹 트리 노드 별 이벤트 현황 정보를 조회한다.
   * @author Ju
   * @return {[type]} [description]
   */
  getEventStatusOfTreeNodes() {
    return axios.get(`${baseUrl}/common/tree/get-event-status-of-tree-nodes.do`);
  },
  /**
   * 논리 / 물리 그룹 트리 노드 검색 대상 개수를 조회한다.
   * @author Ju
   * @param  {String} searchKeyword 검색 키워드
   * @param  {String} treeType      트리 타입 (논리 / 물리)
   * @return {[type]}               [description]
   */
  getTreeSearchObjNodeCount(searchKeyword, treeType) {
    return axios.get(`${baseUrl}/common/tree/get-tree-search-obj-node-count.do`, { params: { searchKeyword, treeType } });
  },
};



// WEBPACK FOOTER //
// ./src/api/common/tree.js